import { render } from "./QrIcon.vue?vue&type=template&id=c3a58298&scoped=true"
const script = {}

import "./QrIcon.vue?vue&type=style&index=0&id=c3a58298&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3a58298"]])

export default __exports__